import { AsyncActions } from '@telstra-connect/standard-actions/';
import { BILLING_BRAINTREE_PAYMENT_TOKEN } from './action-types';
import { IPaymentTokenData } from '../state/get-payment-token';

export interface IGetPaymentTokenAction extends AsyncActions.IAsyncFetchableAction<BILLING_BRAINTREE_PAYMENT_TOKEN> {
}

export interface IGetPaymentTokenSuccessAction extends AsyncActions.IAsyncAction<BILLING_BRAINTREE_PAYMENT_TOKEN> {
    data: IPaymentTokenData;
}

export type GetPaymentTokenErrorAction = AsyncActions.IAsyncErrorAction<BILLING_BRAINTREE_PAYMENT_TOKEN>;

export const getPaymentTokenInitiated = (): IGetPaymentTokenAction => ({
    status: AsyncActions.AsyncActionState.Initiated,
    type: BILLING_BRAINTREE_PAYMENT_TOKEN,
    isFetchable: true
});

export const getPaymentTokenSuccess = (data: IPaymentTokenData): IGetPaymentTokenSuccessAction => {
    return ({
        status: AsyncActions.AsyncActionState.Success,
        type: BILLING_BRAINTREE_PAYMENT_TOKEN,
        data
    })
};

export const getPaymentTokenError = (error: string, errorCode?: string): GetPaymentTokenErrorAction => {
    return ({
        status: AsyncActions.AsyncActionState.Failure,
        type: BILLING_BRAINTREE_PAYMENT_TOKEN,
        error,
        errorCode
    })
};
